module.exports = __webpack_public_path__ + "img/TECNOLOGIA-IGNIS-2021-1.0f4901e0.jpg";